import { sectorsList, sampleDescriptionsList } from '@/config/constants';
import { locationsManagementApi, customersApi } from '@/api';
import { filterOptions } from '@/config/enumOptions';

const customerSampleAnalysesFilters = [
  {
    name: 'customerId',
    label: 'customerIdOrName',
    type: 'autocomplete',
    whereOperator: '=',
    autocompleteSearch: async (queryString, cb) => {
      const customersResponse = await customersApi.autocompleteFetch(
        'name',
        queryString,
        false,
        true
      );
      const filteredResults = customersResponse.data.map((c) => ({
        label: `${c.id} ${c.name}`,
        value: c.id,
      }));
      cb(filteredResults);
    },
  },
  {
    name: 'sampleId',
    label: 'customerSampleId',
    type: 'number',
    whereOperator: '=',
  },
  {
    name: 'orderId',
    label: 'orderId',
    type: 'text',
    whereOperator: '=',
  },
  {
    name: 'analysisCode',
    label: 'analysisCode',
    type: 'text',
    whereOperator: '=',
  },
  {
    name: 'orderSentAt',
    label: 'orderDate',
    type: 'dateDay',
    // whereOperator: 'regexp',
  },
  {
    name: 'productName',
    label: 'productName',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'lot',
    label: 'lot',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'sector',
    label: 'sector',
    type: 'select',
    whereOperator: '=',
    options: filterOptions(sectorsList, 'enums.sectors'),
  },
  {
    name: 'sampleDescription',
    label: 'sampleDescription',
    type: 'select',
    filterable: true,
    whereOperator: '=',
    options: filterOptions(sampleDescriptionsList, 'enums.sampleDescriptions'),
  },
  {
    name: 'locationId',
    label: 'locationIdOrName',
    type: 'autocomplete',
    whereOperator: '=',
    autocompleteSearch: async (queryString, cb) => {
      const locationsResponse = await locationsManagementApi.autocompleteFetch(
        'name',
        queryString,
        false,
        true
      );
      const filteredResults = locationsResponse.data.map((c) => ({
        label: c.name,
        value: c.id,
      }));
      cb(filteredResults);
    },
  },
  {
    name: 'hasLocation',
    label: 'hasLocation',
    type: 'select',
    whereOperator: '=',
    options: [
      {
        value: false,
        label: 'customerSampleAnalyses.hasLocation.toBeAssigned',
      },
      { value: true, label: 'customerSampleAnalyses.hasLocation.assigned' },
    ],
  },
];

export default customerSampleAnalysesFilters;
